import { render, staticRenderFns } from "./complaintStatisticsCopy.vue?vue&type=template&id=b750281c&scoped=true"
import script from "./complaintStatisticsCopy.vue?vue&type=script&lang=js"
export * from "./complaintStatisticsCopy.vue?vue&type=script&lang=js"
import style0 from "./complaintStatisticsCopy.vue?vue&type=style&index=0&id=b750281c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b750281c",
  null
  
)

export default component.exports